export var DEFAULT = "default";
export var HOLLOW = "hollow";
export var BORDER_LESS = "borderless";
